/// <reference path="../wpt.ts" />
/*
    Custom query template to be launched from custom query widget.
*/
var WPTNamespace;
(function (WPTNamespace) {
    var Navigation;
    (function (Navigation) {
        class DetailLayoutCustomQuery extends Navigation.DetailLayoutBaseClass {
            constructor(typeName, core, handler, custom, context, readyCallback = null, secondaryActivationCallback = null) {
                super(typeName, core, handler, custom, context, readyCallback, secondaryActivationCallback);
                this._autoListCollapse = "Hide";
                this.secondaryActivation = (context) => {
                    
                    // Delegate the bulk fo the work to our owned widgets
                    super.secondaryActivation(context);
                    // Local specialist processing
                    this._context = context;
                    let listWidgetSelector = `#topTablePlaceHolder #collapsePanel`;
                    switch (context.ActivationType) {
                        case Navigation.LayoutActivationType.DOCUMENT_SELECTED:
                            if ((this._autoListCollapse == "Hide") || ((this._autoListCollapse == "Responsive") && (this._core.Helper.isNarrowDevice()))) {
                                $(listWidgetSelector).collapse('hide');
                            }
                            break;
                        case Navigation.LayoutActivationType.DOCUMENT_DESELECTED:
                            $(listWidgetSelector).collapse('show');
                            break;
                    }
                };
                let appConfig = this._core.Config.getApplicationConfig();
                if (appConfig.hasOwnProperty("DetailViews")) {
                    let viewConfig = appConfig.DetailViews[this._name];
                    if (viewConfig != null) {
                        if (viewConfig.hasOwnProperty('CollapseListOnSelect'))
                            this._autoListCollapse = viewConfig.CollapseListOnSelect;
                    }
                }
            }
        }
        Navigation.DetailLayoutCustomQuery = DetailLayoutCustomQuery;
    })(Navigation = WPTNamespace.Navigation || (WPTNamespace.Navigation = {}));
})(WPTNamespace || (WPTNamespace = {}));
